export const scadaFileLoadLogMenuName = 'Menu::MenuG:ScadaFileLoadLog';
export const scadaFileGenerateLogMenuName = 'Menu::MenuG:ScadaFileGenerateLog';
export const scadaSchedulerLogMenuName = 'Menu::MenuG:ScadaSchedulerLog';
export const thirdPartyIntegrationMenuName = 'Menu::MenuG:ThirdPartyIntegration';
